import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/seayatech1/aztangofest-fe/src/components/design/pages/registration-flow-page/index.tsx");
